import type { AdminCustomerCart } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";

export class CustomerCartsState {
  /** The customer served, carried for the tabs' links. */
  constructor(readonly customerId: string | null = null) {}
  /** Null until the shell has resolved the shop. */
  readonly shopId = new Rx<string | null>(null);
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly carts = new RxList<AdminCustomerCart>();
  readonly openCarts = new Rx(0);
}

export abstract class CustomerCartsActions {
  abstract reload(): void;
}
